module.exports = __webpack_public_path__ + "img/index_mobile_middle_pic_4.fb88fd43.png";